import { createRouter, createWebHashHistory } from 'vue-router'
const routes = [
    {
        path: "/",
        component: ()=>import("@/view/Home.vue")
    },
    {
        path: "/case",
        component: ()=>import("@/view/Case.vue")
    },
    {
        path: "/about",
        component: ()=>import("@/view/About.vue")
    },
    {
        path: "/news",
        component: ()=>import("@/view/News.vue")
    },
    {
        path: "/newsDetail/:nid",
        component: ()=>import("@/view/NewsDetail.vue")
    }
]

const router = createRouter({
    base: '/',
    mode: 'hash',
    history:createWebHashHistory(),
    routes
})

export default router;
